import React from 'react'
import Helmet from 'react-helmet'
import Layout from '../components/layout'

const About = (props) => (
  <Layout>
    <Helmet>
      <title>About Me</title>
    </Helmet>

    <div id="main" className="alt">
      <section id="about">
        <div className="inner">
          <header className="major">
            <h1>About Me</h1>
          </header>
          <p>
            Hey, I’m Jonna Bonnette. Thanks for visiting my website! I’m a social media and advertising consultant based out of Brandon, Mississippi. When it comes to advertising, I do everything from high resolution print advertising for newspapers, magazines, etc… to scheduled social media posts across multiple platforms. Throughout my career, I have been in several marketing positions, ranging from grassroots marketing and event coordinating to an in-house marketing director. In September 2018, I decided to start working for myself independently, using the knowledge I gained working in the field.
          </p>
        </div>
      </section>
    </div>
  </Layout>
)

export default About
